var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mb-0"},[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"mr-2",attrs:{"outlined":"","color":"primary"},on:{"click":function($event){return _vm.resetPassword()}}},'v-btn',attrs,false),on),[_vm._v(" RESET ")])]}}])},[_c('span',[_vm._v("Send an email with a link to Reset Password")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }